import script from "./FooterUzafoundation.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterUzafoundation.vue?vue&type=script&setup=true&lang=js"

import "./FooterUzafoundation.vue?vue&type=style&index=0&id=30627f79&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30627f79"]])

export default __exports__